/* eslint-disable react/prop-types */
import classes from "./composed-view-eleven.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
function ComposedViewEleven({ title, onPdfClick }) {
  return (
    <Flex
      align="flex-start"
      direction="row"
      justify="flex-start"
      className={classes.container}
    >
      <Label color="secondary" align="start" weight="bold" onClick={onPdfClick}>
        {title}
      </Label>

      <img
        src={"/images/icons/cta-arrow.svg"}
        alt="pdf"
        className={classes.arrow}
        onClick={onPdfClick}
      />
    </Flex>
  );
}

export default ComposedViewEleven;
